// Llamadas del navegador a la api (mismo origen: el rewrite /v1/* de Next la reenvía por la
// red interna, con la cookie de sesión HttpOnly de plataforma). Las mutaciones van como
// JSON: la protección CSRF de la api rechaza cualquier otro formato.
export interface ApiResult<T> {
  status: number;
  body: T | null;
}

export async function sendJson<T>(
  method: string,
  path: string,
  body?: unknown,
): Promise<ApiResult<T>> {
  const response = await fetch(path, {
    method,
    headers: body === undefined ? {} : { 'content-type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
    cache: 'no-store',
  });
  const text = await response.text();
  let parsed: T | null;
  try {
    parsed = text ? (JSON.parse(text) as T) : null;
  } catch {
    parsed = null;
  }
  return { status: response.status, body: parsed };
}

/** Mensaje de error de una respuesta de la api ({ code, message }), o el genérico. */
export function messageOf(body: unknown, fallback: string): string {
  if (typeof body === 'object' && body !== null && 'message' in body) {
    const message = (body as { message: unknown }).message;
    if (typeof message === 'string' && message) return message;
  }
  return fallback;
}
